var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgClosedBetaIcon = function SvgClosedBetaIcon(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 584 584",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M291.667 550C434.342 550 550 434.342 550 291.667c0-142.674-115.658-258.334-258.333-258.334-142.674 0-258.334 115.66-258.334 258.334C33.333 434.342 148.993 550 291.667 550Zm0 33.333c161.083 0 291.666-130.583 291.666-291.666S452.75 0 291.667 0 0 130.584 0 291.667C0 452.75 130.584 583.333 291.667 583.333Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m251.697 384.17 18.73 31.292 74.922-125.169h-37.461l-56.191 93.877Z",
    style: {
      fill: "#ff8181",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.888 290.35h37.461l-74.922-124.888-18.73 31.18 56.191 93.708Z",
    style: {
      fill: "#ffb3b3",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.571 290.293H158.11l74.922 124.889h37.516l-18.73-31.012-56.247-93.877Z",
    style: {
      fill: "#e24e4e",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m195.612 290.35 56.079-93.708 18.73-31.18H95.679V415.07h37.461V202.923h77.389l-52.378 87.427h37.461Z",
    style: {
      fill: "#e11010",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.743 349.91v65.552h-28.231V221.023c0-17.035 5.083-30.554 15.248-40.556 10.165-10.003 24.092-15.005 41.782-15.005 16.187 0 29.075 3.983 38.671 11.947 9.595 7.964 14.391 18.982 14.391 33.054 0 9.632-3.1 18.706-9.308 27.224-6.208 8.517-14.204 14.257-23.992 17.22v.557c15.054 2.592 26.534 8.055 34.434 16.391 7.9 8.336 11.85 19.168 11.85 32.498 0 15.557-5.455 28.242-16.367 38.055-10.913 9.814-25.4 14.72-43.467 14.72-12.8 0-24.464-2.406-34.999-7.218h-.012Zm18.066-81.113v-22.779c10.166-1.114 18.633-4.91 25.399-11.389 6.771-6.479 10.159-13.796 10.167-21.949 0-16.3-8.467-24.45-25.4-24.45-9.034 0-15.995 2.871-20.885 8.615-4.89 5.745-7.335 13.8-7.335 24.166V325.46c10.912 6.297 21.543 9.446 31.891 9.446 10.35 0 18.35-2.591 23.992-7.775 5.645-5.183 8.466-12.59 8.466-22.221 0-21.113-15.429-33.15-46.295-36.113Z",
    style: {
      fill: "#f2f2f2",
      fillRule: "nonzero"
    }
  }));
};
export default SvgClosedBetaIcon;